export const currencyCodes = {
  RUB: '\u20bd',
  USD: '\u0024',
};
